import * as React from "react";
import { withRouter } from "react-router-dom";

import { HeaderPanel, Switcher, SwitcherItem } from "carbon-components-react";
import { Maximize16 } from "@carbon/icons-react";

import { ToolPanelEnum, panelToFullToolUrl } from "../shared";

const styles = require("./styles.module.scss");

interface IProps {
  appId: number;
  panelOpenTo: null | ToolPanelEnum;
  hidePanel: Function;
  children: React.ReactNode;

  // withRouter
  history: any;
  location: any;
  match: any;
}

const ToolPanel = ({ appId, panelOpenTo, hidePanel, children, history }: IProps) => {
  const ariaLabel = `Open {panelOpenTo} full-screen`;

  const onClick = () => {
    hidePanel();
    history.push(panelToFullToolUrl(appId, panelOpenTo));
  };

  return (
    <HeaderPanel aria-label={`${panelOpenTo} tool panel`} expanded={!!panelOpenTo}>
      <Switcher aria-label={ariaLabel}>
        <SwitcherItem aria-label={ariaLabel} onClick={onClick}>
          <Maximize16 className={styles.toolPanelIcon} /> Open {panelOpenTo}…
        </SwitcherItem>
      </Switcher>
      <div className={styles.toolPanelContainer}>
        <div className={styles.toolPanelContent}>{children}</div>
      </div>
    </HeaderPanel>
  );
};

export default withRouter(ToolPanel);
